export const organizationSizes = [
  { value: 1, text: '1-3 personer' },
  { value: 4, text: '4-8 personer' },
  { value: 9, text: '9-15 personer' },
  { value: 16, text: '16-30 personer' },
];
